import {createClient} from "@sanity/client"

export const sanityClient = createClient({
    projectId: "gjtdfh3l",
    dataset: "production",
    token: process.env.SANITY_TOKEN,
    useCdn: process.env.NEXT_PUBLIC_ENV !== "development",
    apiVersion: "v1",
});
